import classNames from 'classnames';
import Link from 'next/link';
import { useState } from 'react';

import ActiveLink from '../ActiveLink/ActiveLink';
import BusinessContactForm from '../BusinessContactForm/BusinessContactForm';

import styles from './FooterLink.module.scss';

const FooterLink = ({ list, ...restProps }) => {
  const [activeModal, setActiveModal] = useState(false);
  const openModal = () => {
    setActiveModal(true);
  };
  const closeModal = () => {
    setActiveModal(false);
  };

  const renderSwitch = (item) => {
    switch (item?.type) {
      case 'download':
        return (
          <a
            className={styles.droppedLink}
            href={item?.button_download_file}
            itemScope
            itemType='http://schema.org/DownloadAction'
            title={item?.text}
            aria-label={item?.text}
          >
            {item?.text}
          </a>
        );
      case 'pop-up':
        return (
          <button
            className={styles.write_us}
            onClick={openModal}
            itemScope
            itemType='http://schema.org/Action'
            title={item?.text}
            aria-label={item?.text}
          >
            {item?.text}
          </button>
        );
      default:
        return (
          <Link
            href={`/${item?.slug}`}
            itemScope
            itemType='http://schema.org/WebPage'
          >
            <a
              className={styles.droppedLink}
              title={item?.text}
              aria-label={item?.text}
            >
              {item?.text}
            </a>
          </Link>
        );
    }
  };

  const renderChildList = (item) => {
    return (
      <li key={item.id} className={styles.link}>
        {renderSwitch(item)}
      </li>
    );
  };

  return (
    <div itemScope itemType='http://schema.org/Action'>
      <div className={styles.linkContainer}>
        {!list?.slug ? (
          <span className={classNames(styles.link)}>{restProps.children}</span>
        ) : (
          <>
            <ActiveLink href={`/${list?.slug}`}>
              <a
                className={classNames(`${styles.link} ${styles.linkActive}`)}
                style={{ cursor: 'pointer' }}
                title={'Bakcell'}
                aria-label={'Bakcell'}
              >
                {restProps.children}
              </a>
            </ActiveLink>
          </>
        )}
      </div>
      {list?.children && (
        <ul className={styles.listItem}>
          {list.children?.map(renderChildList)}
        </ul>
      )}
      <BusinessContactForm
        activeModal={activeModal}
        clearTariff={closeModal}
        hasEmployeesCount={false}
      />
    </div>
  );
};

export default FooterLink;
